import r from"./_baseIsNative.js";import a from"./_getValue.js";var t=r,e=a;var o=function(r,a){var o=e(r,a);return t(o)?o:void 0};export{o as default};
//# sourceMappingURL=_getNative.js.map
